import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import Expertise from '../list/expertise';
import Appraisal from '../list/appraisal';

const API_PATH = 'expertise';
const API_PATH_APPRAISALS = `${API_PATH}-appraisals`;

export const ExpertiseManager = {
  objects: objectsRHandler(`${API_PATH}s`, Expertise),
  appraisals: objectsRHandler(API_PATH_APPRAISALS, Appraisal),

  complete: ({ args = [], params } = DEFAULT_PARAMS) => {
    const [id] = args;
    return rHandler(
      apiService.post(`${API_PATH}s/${id}/complete`, params),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  },
};
